import store from "@/core/services/store";

export default {
  bind(el, binding) {
    const updateBlur = () => {
      const isPresentationMode = store.getters["isPresentationMode"];

      if (isPresentationMode) {
        el.classList.add("presentation-blur");
      } else {
        el.classList.remove("presentation-blur");
      }
    };

    updateBlur();

    el._unwatchPresentation = store.watch(
      (state) => state.presentation.presentationMode,
      updateBlur
    );
  },
  unbind(el) {
    if (el._unwatchPresentation) {
      el._unwatchPresentation();
    }
  }
};
